import { Config } from "../landing-config";
import { ico_picked } from "../map-config";


const maxFileRows = 500;
export const SCUOLE_CONFIG: Config = {
    data: {
        route: 'scuole',
        page_title: 'Scuole | Open Fiber',
        service_title: 'Scuole',
        service_description: '',
        service_name: 'active',
        service_slug: 'scuole',
        errorTimeout: 0,
        feasibilityModelSingle: true,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/servizioscuole/massivep2p/detail',
                massiveUploadPath: '/servizioscuole/massivep2p/upload',
                massiveDownloadPath: '/servizioscuole/data/massive/import.xlsx',
                massiveP2pSalesforcePath: '/servizioscuole/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/servizioscuole/p2p',
			bboxPath: '/marketing/school/building',
			buildingSearchParams: null
        },
        dynamic_aend_name: 'SCUOLE'
    },
    multiple_points: {
        variable: false,
        max: 1,
        points: {
            b_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: true,
                city_noa: false,
                city_pop: false,
                city_poi: false,
                city_building: false,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: false,
            },
            a_end: null
        },
        initial_points: ['b_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: false,
        marker_default_icon: ico_picked,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: false,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: true,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: false,
    },
    area_types: ['CoveredAB', 'CoveredCD'], // ,// TODO per abilitare AGF 'CoveredAGF'
    area_types_short: null,
    kml: false,
    pop: {
        load: true,
        view_initial: false,
        click: false,
        loadCities: false
    },
    pop_ola: {
        load: false,
        view_initial: false,
        click: false
    },
    pcn: {
        load: true,
        view_initial: false,
        click: false
    },
    pop_agf: {
        load: true,
        view_initial: false,
        click: false
    },
    poi: {
        load: true,
        view_initial: false,
        click: false,
        x_pop: false,
        is_registered: false,
        custom_research_method: null,
        loadCities: false
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: false,
        click: false,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: true,
        click: true,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}